import * as React from 'react';
import { Modal, Button } from 'semantic-ui-react';
import { getI18n } from 'services/i18n-service';
import { translations } from 'types/translations';
import { AlertMessage } from './alert-content';
import { Alert } from 'types/alert';

import './styles.css';
import { BaseModal } from 'components/base-modal/component';

export interface Props {
  alert: Alert;
  close: (clientTransactionId: string) => void;
}

const handleClose = Symbol();
const handleKeyDown = Symbol();

export class AlertModal extends React.Component<Props> {

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {
    document.addEventListener('keydown', this[handleKeyDown], false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this[handleKeyDown], false);
  }

  render() {
    const i18n = getI18n();

    const modalActionButton = (
      <Button
        className={'ack-button'}
        onClick={this[handleClose]}>
        {i18n.t(translations.Acknowledge)}
      </Button>
    );

    return (
      <BaseModal
        open={true}
        modalProps={{ className: 'alert-modal', size: 'small' }}
        headerText={i18n.t(translations.Alert)}
        showHeaderClose={false}
        closeHandler={this[handleClose]}
        footerClassName={'modal-footer alert-modal-footer'}
        actionButton={modalActionButton}
      >
        <Modal.Description>
          <AlertMessage
            epc={this.props.alert.item.epc}
            errorKey={this.props.alert.errorKey}
            alertReason={this.props.alert.alertReason}
            additionalMessage={this.props.alert.additionalMessage} />
        </Modal.Description>
      </BaseModal>
    );
  }

  [handleClose] = () => {
    this.props.close(this.props.alert.item.clientTransactionId.toString());
  }

  [handleKeyDown] = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      this[handleClose]();
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/alert/component.tsx